<div class="action-card d-flex flex-row">
  <div class="card-width d-flex flex-column">
    <span class="title-text">
      {{ 'page.shift_timeline_draft_action_card.title' | translate }}
    </span>
    <span class="description-text">
      {{ 'page.shift_timeline_draft_action_card.description' | translate }}
    </span>
  </div>
  <div class="d-flex align-items-center">
    <button
      nz-button
      nzType="default"
      class="me-2"
      (click)="goBackToShiftTimeline()"
    >
      {{ 'general.cancel' | translate }}
    </button>
    @if (
      {
        numberOfChanges: (changedShiftIds$ | async)?.length ?? 0,
      };
      as data
    ) {
      <button
        nz-button
        nz-tooltip
        [nzTooltipTitle]="
          'page.shift_disposition.wilson_ai_draft.alert' | translate
        "
        (click)="saveDraft(data.numberOfChanges)"
        [disabled]="isSaving || !(data.numberOfChanges > 0)"
        [ngClass]="
          isSaving || !(data.numberOfChanges > 0)
            ? ''
            : 'save-button text-white'
        "
      >
        @if (isSaving) {
          <span
            class="spinner-border spinner-border-sm me-1"
            role="status"
            aria-hidden="true"
          ></span>
        }
        {{
          data.numberOfChanges > 1
            ? ('page.shift_timeline_draft_action_card.apply_multiple_changes_button.text'
              | translate: { number: data.numberOfChanges })
            : ('page.shift_timeline_draft_action_card.apply_singular_change_button.text'
              | translate: { number: data.numberOfChanges })
        }}
      </button>
    }
  </div>
</div>
